var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical_line homeComTitle hasLine"},[_c('span',{staticClass:"titleLine"}),_c('span',{staticClass:"flex_1 fs16 co_333"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }